import { t } from "@/i18n-js/instance";
import { Form } from "@circle-react-uikit/Form";
import { FormItem } from "../FormItem";
import { PRODUCT_AREAS, TICKET_PRIORITIES, TICKET_TYPES } from "../constants";

export const SendUsAMessageForm = () => (
  <div className="flex max-h-full flex-col px-6">
    <FormItem hidePlaceholder={false} name="type">
      <Form.Select name="type" data={TICKET_TYPES} />
    </FormItem>
    <FormItem hidePlaceholder={false} className="!pt-2" name="area">
      <Form.Select name="area" data={PRODUCT_AREAS} />
    </FormItem>
    <FormItem name="priority" className="!pt-2" hidePlaceholder={false}>
      <Form.Select
        name="priority"
        inputContainerClassName="priority-select-input-container"
        data={TICKET_PRIORITIES}
      />
    </FormItem>
    <FormItem className="!pt-2" name="text">
      <Form.Input name="text" variant="textarea" className="resize-none" />
    </FormItem>
    <div className="my-6 flex justify-between">
      <button
        className="bg-circle px-6 py-2.5 font-bold leading-5 text-white hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-50"
        type="submit"
      >
        {t("support_widget.send_message_form.button_label")}
      </button>
    </div>
  </div>
);
